<!--TODO: implement functionality for lazy standalone components loading-->
<bosch-ui-dropdown-desktop
  *showOnScreen="'desktop'"
  [open]="isOpen$ | async"
  [customDropdownListWidth]="325"
  [dropdownOffsetY]="15"
  (dropdownChange)="onDropdownChange($event)"
  (dropdownPositionChange)="onDropdownPositionChange($event)"
>
  <ng-container *ngTemplateOutlet="dropdownValueTemplate" dropdown-value></ng-container>
  <ng-container *ngTemplateOutlet="dropdownValueList" dropdown-list></ng-container>
</bosch-ui-dropdown-desktop>

<bosch-ui-dropdown-mobile *showOnScreen="'mobile'" [open]="isOpen$ | async">
  <ng-container *ngTemplateOutlet="dropdownValueTemplate" dropdown-value></ng-container>
  <ng-container
    *ngTemplateOutlet="dropdownValueList; context: { $implicit: 'dropdown-list__content_mobile' }"
    dropdown-list
  ></ng-container>
</bosch-ui-dropdown-mobile>

<ng-template #dropdownValueTemplate>
  <bosch-ui-button [type]="buttonType.Integrated">
    <bosch-ui-icon [name]="iconNames.GlobeLanguage" button-icon></bosch-ui-icon>
    <span>{{ value$ | async }}</span>
  </bosch-ui-button>
</ng-template>

<ng-template #dropdownValueList let-mobileCssClass>
  <div
    class="dropdown-list"
    [class.open]="isOpen$ | async"
    [class.position-top]="(dropdownPosition$ | async) === 'top'"
    [class.position-bottom]="(dropdownPosition$ | async) === 'bottom'"
  >
    <div class="tw-flex">
      <p class="tw-flex-1 tw-text-bosch-xl tw-font-strong tw-pl-8 tw-pt-6 tw-m-0">
        {{ 'common.uiKit.monitoring.label.languageSelect' | translate }}
      </p>
      <bosch-ui-button class="tw-relative tw-z-[11]" [type]="buttonType.Close" (click)="onClose()"></bosch-ui-button>
    </div>
    <div class="dropdown-list__content {{ mobileCssClass }}">
      <span
        *ngFor="let language of languages"
        [class.tw-bg-bosch-gray-80]="(value$ | async) === language"
        [class.hover:tw-bg-bosch-gray-80]="(value$ | async) === language"
        [class.hover:tw-bg-bosch-gray-90]="(value$ | async) !== language"
        class="tw-block tw-px-8 tw-py-3 tw-cursor-pointer active:tw-bg-bosch-gray-80"
        (click)="onOptionClick(language)"
      >
        {{ 'common.language.' + language | lowercase | translate }} - {{ language | uppercase }}
      </span>
    </div>
  </div>
</ng-template>
